import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('lp', 19, { msid: 'cea1e625-ef4a-40d7-bef8-2d50ce63a50e' });

$w.onReady(async function () {
    pageEvents();
});
async function pageEvents() {
    $w("#input2").onFocus(() => {
        $w('#warning').hide();
        $w('#text165').show();
        $w('#input2').placeholder = ''
    })
    $w("#input2").onKeyPress(() => {
        $w('#warning').hide();
        $w('#text165').show();
        $w('#input2').placeholder = ''
    })

    $w("#input2").onBlur(() => {
        if ($w("#input2").value === '') {
            $w('#text165').hide();
            $w('#input2').placeholder = 'Business email'
        }
        setTimeout(() => {
            console.log($w("#input2").valid)
            $w("#input2").valid ? $w('#warning').hide() : $w('#warning').show();
        }, 100)

    })

    $w("#input2").onChange(() => {
        if ($w("#input2").value === '') {
            $w('#text165').hide();
            $w('#input2').placeholder = 'Business email'
        }
        setTimeout(() => {
            console.log($w("#input2").valid, 'change')
            $w("#input2").valid ? $w('#warning').hide() : $w('#warning').show();
        }, 200)
    })

    $w('#buttonSubmit1').onClick(async () => {
        $w('#buttonSubmit1').disable();
        if ($w("#input2").valid) {
            await sendFormData();
        } else {
            $w('#buttonSubmit1').enable();
        }
    })
}

async function sendFormData() {
    const formData = {
        email: $w('#input2').value,
        source: wixLocation.url
    }
    let item = await wixData.insert("blogsubscribeDB", formData);

    const biEventObject = {
        evid: 703,
        button_name: 'subscribe_to_blog',
        is_valid: true,
        topic: 'partners lp',
        url: wixLocation.url
    };
    biLogger.log(biEventObject);

    console.log('sent')
    await wixLocation.to('https://www.wix.com/partners/blog-all-set')
}

// wixWindow.scrollBy(0, 500)
//   .then( ( ) => {
//     console.log("Done with scroll");
// } );

// import { biLoggerFactory } from 'wix-private';
// import { submitButtonEvent } from 'public/events-firing.js';
// import { getLoggedInUserId } from 'public/users.js';
// import wixData from 'wix-data';
// import wixWindow from 'wix-window';
// import wixLocation from 'wix-location';

// const url = wixLocation.url;
// let lp = wixLocation.path[2];
// let campaign = wixLocation.query.utm_campaign;
// if (campaign) { campaign = campaign.split('_')[2]; }
// let language, userId, countryCode;
// let formfactor = wixWindow.formFactor
// let Mobile = ''
// const biLogger = biLoggerFactory('lp', 19, { msid: 'cea1e625-ef4a-40d7-bef8-2d50ce63a50e' });

// $w.onReady(async function () {
//     formfactor === 'Mobile' ? Mobile = 'Mobile' : Mobile = ''
//     console.log(formfactor, Mobile)
//     pageEvents();
//     language = await wixWindow.browserLocale.slice(0, 2);
//     countryCode = await wixWindow.browserLocale.slice(3);
//     const success = await getLoggedInUserId();
//     userId = success.slice(success.indexOf('"guid":"') + 8, success.indexOf('"guid":"') + 44);
// });
// async function pageEvents() {
//     const inputs = ["Fullname", "Email", "Phone"];
//     inputs.forEach((input) => {
//         input = input + Mobile
//         console.log(input)
//         $w("#input" + input).onFocus(() => {
//             $w('#warning' + input).hide();
//             // $w('#title' + input).expand();
//             $w('#title' + input).show();
//             $w('#input' + input).placeholder = ''
//         })
//         $w("#input" + input).onKeyPress(() => {
//             $w('#warning' + input).hide();
//             // $w('#title' + input).expand();
//             $w('#title' + input).show();
//             $w('#input' + input).placeholder = ''
//         })

//         $w("#input" + input).onBlur(() => {
//             if ($w("#input" + input).value === '') {
//                 // $w('#title' + input).collapse();
//                 $w('#title' + input).hide();
//                 $w('#input' + input).placeholder = getPlaceHolderText(input)
//             }
//             $w("#input" + input).valid ? $w('#warning' + input).hide() : $w('#warning' + input).show();
//         })

//         $w("#input" + input).onChange(() => {
//             if ($w("#input" + input).value === '') {
//                 // $w('#title' + input).collapse();
//                 $w('#title' + input).hide();
//                 $w('#input' + input).placeholder = getPlaceHolderText(input)
//             }
//             $w("#input" + input).valid ? $w('#warning' + input).hide() : $w('#warning' + input).show();
//         })
//     })

//     $w('#buttonLetsTalk').onClick(async () => {
//         $w('#buttonLetsTalk' ).disable();
//         if (formValidation()) {
//             console.log('send form data')
//             await sendFormData();

//         } else {
//             $w('#buttonLetsTalk').enable();
//         }
//     })

//     $w("#startNowNavSideBar").onClick((event) => {
//         fireEvent('start now')

//     });

// }

// function getPlaceHolderText(input) {
//     let placeHolder;
//     input = input.replace('Mobile', '')
//     switch (input) {
//     case 'Fullname':
//         placeHolder = 'Full name'
//         break;
//     case 'Email':
//         placeHolder = 'Business email'
//         break;
//     case 'Phone':
//         placeHolder = 'Phone number'
//         break;
//     }
//     return placeHolder
// }

// async function sendFormData() {
//     const formData = {
//         inputLp: lp,
//         uuid: userId,
//         language: language,
//         countryCode: countryCode,
//         inputCampaign: campaign,
//         inputEmail: $w('#inputEmail' + Mobile).value,
//         inputFullName: $w('#inputFullname' + Mobile).value,
//         inputPhone: $w('#inputPhone' + Mobile).value
//     }
//     let item = await wixData.insert("formDB", formData);
//     await submitButtonEvent(item._id, url);
//     await wixLocation.to('https://www.wix.com/experts/thank-you/partner-team')
// }

// function formValidation() {
//     let valid = true;
//     $w("#checkboxTerms" + Mobile).updateValidityIndication();
//     if (!$w('#checkboxTerms' + Mobile).checked) {
//         valid = false;
//     }
//     if (!$w('#inputFullname' + Mobile).valid) {
//         $w('#warningFullname' + Mobile).show();
//         valid = false
//     }
//     if (!$w('#inputEmail' + Mobile).valid) {
//         $w('#warningEmail' + Mobile).show();
//         valid = false
//     }

//     if (!$w('#inputPhone' + Mobile).valid) {
//         $w('#warningPhone' + Mobile).show();
//         valid = false
//     }
//     return valid;
// }

// async function fireEvent(buttonName) {
//     try {
//         const biEventObject = {
//             evid: 703,
//             button_name: buttonName,
//             is_valid: true,
//             topic: 'wix partners site',
//             url: wixLocation.url
//         };
//         await biLogger.log(biEventObject);
//     } catch (error) {
//         console.log(error, "sth went wrong")
//     }
// }